<ng-container *ngIf="licenseValidated else noLicense">
  <div class="app-header-strip" dir="ltr" [ngClass]="{'hidden-on-mobile' : !showHideApplicationHeaderService.isVisible()}">
    <img class="logo" [src]="logo ? logo : ''"  alt="Logo"/>
    <app-language-selection></app-language-selection>
  </div>

  <div class="app-container">
    <router-outlet></router-outlet>
    <div class="k-overlay" *ngIf="popupWindowService.anyPopupsOpen"></div>
  </div>
</ng-container>

<ng-template #noLicense>
  <div class="no-license">
    <router-outlet></router-outlet>
  </div>
</ng-template>

<ng-template #closePopupTitle>
  <div class="popup-header">
    <div class="popup-title">{{"AreYouSureYouWantToLeave" | cpTitleTranslate | async}}</div>
    <i class="pp-icon-close popup-close" (click)="popupWindowService.closeLatestPopup(false)"></i>
  </div>
</ng-template>

<ng-template #closePopupContent>
<div class="popup-body">
  <div class="popup-body-text-content">
    <i [ngClass]="'pp-icon-error'"></i>
    <div>
      <div class="text-bold">{{"AreYouSureYouWantToLeave" | cpLabelTranslate | async}}</div>
      <div>{{"AnyChangesYouMadeMayBeLost" | cpLabelTranslate | async}}</div>
      <div>{{"DoYouWantToLogOut" | cpLabelTranslate | async}}</div>
    </div>
  </div>
</div>
<div class="popup-footer">
  <cp-button-widget-custom class="link-button" captionToTranslate="Logout" (onClick)="popupWindowService.closeLatestPopup(true)"></cp-button-widget-custom>
  <cp-button-widget-custom class="primary-button" captionToTranslate="Cancel" (onClick)="popupWindowService.closeLatestPopup(false)"></cp-button-widget-custom>
</div>
</ng-template>
